var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c(_vm.layout.component,{key:_vm.rerenderKey,tag:"component",attrs:{"options":_vm.layout.options}},[_c('router-view'),_c('ErrorMessage'),_c('NotificationToaster')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }